export default __webpack_public_path__ + "static/media/LogoFooter.3f916bb1.png";